import { useAuthStore } from '@/context/authStore';
import { ArrowLeft, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuthStore();
  const navigate = useNavigate();

  if (!impersonation.isImpersonating) {
    return null;
  }

  const handleStopImpersonation = () => {
    if (impersonation.originalToken && impersonation.originalRefreshToken) {
      stopImpersonation();
      toast.success('Volviendo al panel de administración');
      navigate('/admin');
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg">
      <div className="max-w-screen-2xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Building2 className="h-5 w-5" />
          <span className="text-sm font-medium">
            Estás viendo:{' '}
            <strong className="font-bold">{impersonation.impersonatedTenantName}</strong>
          </span>
        </div>
        <button
          onClick={handleStopImpersonation}
          className="flex items-center gap-2 px-3 py-1.5 bg-white/20 hover:bg-white/30 rounded-lg transition-colors text-sm font-medium"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al Panel Admin
        </button>
      </div>
    </div>
  );
}
